import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import { noop } from 'lodash'
import Hammer from 'hammerjs'
import { getReadableTextColor } from '@helpers/color_scheme_helpers.js'
import { ThemeContext } from '../../../../base/ThemeContext'
import { sanitize } from '@utils/sanitize'

export default class Timespan extends PureComponent {
  constructor(props) {
    super(props)
    this.hammerManager = null
    this.addedHammerListeners = false
  }

  handleTap = hammerEvent => {
    this.props.onTap(hammerEvent, this.tapData())
  }

  handlePanStart = hammerEvent => {
    this.props.onPanStart(hammerEvent)
  }

  handlePanMove = hammerEvent => {
    this.props.onPanMove(hammerEvent)
  }

  handlePanEnd = hammerEvent => {
    this.props.onPanEnd(hammerEvent)
  }

  componentDidMount() {
    this.hammertime()
  }

  componentDidUpdate() {
    this.hammertime()
  }

  componentWillUnmount() {
    this.stopHammertime()
  }

  hammertime() {
    if (!this.hammerManager) {
      this.hammerManager = new Hammer.Manager(ReactDOM.findDOMNode(this), {
        recognizers: [[Hammer.Pan, { threshold: 0, direction: Hammer.DIRECTION_HORIZONTAL }], [Hammer.Tap]],
      })
    }
    this.addHammerListeners()
  }

  stopHammertime() {
    this.removeHammerListeners()
    this.removeHammerManagers()
  }

  addHammerListeners() {
    if (!this.addedHammerListeners && this.hammerManager) {
      this.hammerManager.on('tap', this.handleTap)
      this.hammerManager.on('panstart', this.handlePanStart)
      this.hammerManager.on('panmove', this.handlePanMove)
      this.hammerManager.on('panend', this.handlePanEnd)
      this.addedHammerListeners = true
    }
  }

  removeHammerListeners() {
    if (this.addedHammerListeners && this.hammerManager) {
      this.hammerManager.off('tap')
      this.hammerManager.off('panstart')
      this.hammerManager.off('panmove')
      this.hammerManager.off('panend')
      this.addedHammerListeners = false
    }
  }

  removeHammerManagers() {
    if (this.hammerManager) {
      this.hammerManager.destroy()
      this.hammerManager = null
    }
  }

  tapData() {
    const { timespan } = this.props
    return {
      id: timespan.id,
      timelineItemType: 'timespan',
    }
  }

  render() {
    const { timespan, x, y, width, height, zIndex } = this.props
    const colorScheme = this.context
    const backgroundColor = colorScheme.highlight
    const color = getReadableTextColor(backgroundColor, colorScheme)
    // Note: Before moving to a css transform for positioning, we used to set left to x and top to y
    const transformString = `translate(${x}px, ${y}px)`
    const timelineItemStyle = {
      width: width,
      height: height,
      left: 0,
      top: 0,
      WebkitTransform: transformString,
      MozTransform: transformString,
      msTransform: transformString,
      transform: transformString,
      display: 'block',
      zIndex: zIndex,
      backgroundColor,
      color,
    }
    const contentHolderStyle = {
      width,
      height,
    }

    return (
      <div
        className="timeline-item timeline-timespan z-depth-1"
        style={timelineItemStyle}
        key={`timespan-${timespan.id}`}
      >
        <div className="content-holder" style={contentHolderStyle}>
          <span className="title ellipsify-text" dangerouslySetInnerHTML={{ __html: sanitize(timespan.title) }}></span>
        </div>
      </div>
    )
  }
}
Timespan.contextType = ThemeContext
Timespan.propTypes = {
  timespan: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
    title: PropTypes.string.isRequired,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
  }),
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  zIndex: PropTypes.number.isRequired,
  onTap: PropTypes.func.isRequired,
  onPanStart: PropTypes.func.isRequired,
  onPanMove: PropTypes.func.isRequired,
  onPanEnd: PropTypes.func.isRequired,
}
Timespan.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  onTap: noop,
  onPanStart: noop,
  onPanMove: noop,
  onPanEnd: noop,
}
